import React, { useEffect } from 'react';
import { FiX, FiChevronLeft, FiChevronRight, FiDownload } from 'react-icons/fi';
import './ImageLightbox.css';

interface ImageLightboxProps {
    images: string[];
    currentIndex: number;
    onClose: () => void;
    onIndexChange: (index: number) => void;
}

const ImageLightbox: React.FC<ImageLightboxProps> = ({ images, currentIndex, onClose, onIndexChange }) => {
    
    useEffect(() => {
        const prvHandleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
            if (e.key === 'ArrowRight') prvHandleNext();
            if (e.key === 'ArrowLeft') prvHandlePrev();
        };
        window.addEventListener('keydown', prvHandleKeyDown);
        return () => window.removeEventListener('keydown', prvHandleKeyDown);
    }, [currentIndex, images]);

    if (images.length === 0 || currentIndex < 0 || currentIndex >= images.length) return null;

    const currentUrl = images[currentIndex];

    const prvHandlePrev = () => {
        const newIndex = (currentIndex - 1 + images.length) % images.length;
        onIndexChange(newIndex);
    };

    const prvHandleNext = () => {
        const newIndex = (currentIndex + 1) % images.length;
        onIndexChange(newIndex);
    };

    const prvHandleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="lightbox-overlay" onClick={prvHandleOverlayClick}>
            <button className="lightbox-close" onClick={onClose} title="Cerrar">
                <FiX />
            </button>

            {images.length > 1 && (
                <button className="lightbox-arrow left" onClick={prvHandlePrev} title="Anterior">
                    <FiChevronLeft />
                </button>
            )}

            <div className="lightbox-content">
                <img src={currentUrl} alt={`Captura ${currentIndex + 1}`} className="lightbox-image" />
                
                <div className="lightbox-info">
                    <span className="lightbox-counter">{currentIndex + 1} de {images.length}</span>
                    <a href={currentUrl} download={`captura_${currentIndex + 1}.jpg`} target="_blank" rel="noopener noreferrer" className="lightbox-download-btn" title="Descargar">
                        <FiDownload /> Descargar original
                    </a>
                </div>
            </div>

            {images.length > 1 && (
                <button className="lightbox-arrow right" onClick={prvHandleNext} title="Siguiente">
                    <FiChevronRight />
                </button>
            )}

            {images.length > 1 && (
                <div className="lightbox-thumbnails">
                    {images.map((imgUrl, idx) => (
                        <div 
                            key={idx} 
                            className={`lightbox-thumb ${idx === currentIndex ? 'active' : ''}`}
                            onClick={() => onIndexChange(idx)}
                        >
                            <img src={imgUrl} alt={`Miniatura ${idx + 1}`} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ImageLightbox;
